/* ═══════════════════════════════════════════════════════
   J DESIGN GALLERY — SHOPIFY THEME JAVASCRIPT
   File: assets/jdg-theme.js
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─────────────────────────────────────────
     PROMO CAROUSEL
  ───────────────────────────────────────── */
  (function () {
    var track = document.getElementById('promoTrack');
    var dotsWrap = document.getElementById('promoDots');
    var prevBtn = document.getElementById('promoPrev');
    var nextBtn = document.getElementById('promoNext');
    if (!track) return;

    var slides = track.children;
    var total = slides.length;
    var current = 0;
    var timer;

    // Build dot buttons
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.className = 'jdg-promo-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.dataset.index = i;
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index));
      });
      if (dotsWrap) dotsWrap.appendChild(dot);
    }

    function goTo(n) {
      current = ((n % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.jdg-promo-dot').forEach(function (d, idx) {
          d.classList.toggle('active', idx === current);
          d.setAttribute('aria-pressed', idx === current ? 'true' : 'false');
        });
      }
      resetTimer();
    }

    function resetTimer() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, 4500);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Pause on hover
    track.parentElement.addEventListener('mouseenter', function () { clearInterval(timer); });
    track.parentElement.addEventListener('mouseleave', resetTimer);

    // Touch swipe support
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });

    resetTimer();
  })();


  /* ─────────────────────────────────────────
     MOBILE MENU TOGGLE
  ───────────────────────────────────────── */
  var menuToggle = document.getElementById('menuToggle');
  var jdgNav = document.getElementById('jdgNav');

  if (menuToggle && jdgNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = jdgNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!jdgNav.contains(e.target) && !menuToggle.contains(e.target)) {
        jdgNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && jdgNav.classList.contains('is-open')) {
        jdgNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.focus();
      }
    });
  }


  /* ─────────────────────────────────────────
     ADD TO CART — AJAX
  ───────────────────────────────────────── */
  document.querySelectorAll('.jdg-add-to-cart[data-product-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.dataset.productId;
      var originalText = btn.textContent;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = '✓ Added to Cart!';
        btn.style.background = '#2C6E49';

        // Update cart count badge
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var badge = document.getElementById('cartCount');
        if (badge) badge.textContent = cart.item_count;
        setTimeout(function () {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'View Product';
        btn.style.background = '';
        btn.disabled = false;
        // Fallback — navigate to product page
        if (btn.closest('a')) window.location = btn.closest('a').href;
      });
    });
  });

 


  /* ─────────────────────────────────────────
     STICKY HEADER SHADOW ON SCROLL
  ───────────────────────────────────────── */
  var header = document.querySelector('.jdg-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 28px rgba(26,23,20,0.14)'
        : '0 2px 20px rgba(26,23,20,0.06)';
    }, { passive: true });
  }

});

/* ═══════════════════════════════════════════════════════
   COLLECTION PAGE — FILTERS & SIDEBAR
   ═══════════════════════════════════════════════════════ */
(function () {

  /* ── Filter group expand/collapse ── */
  document.querySelectorAll('.jdg-filter-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = this.nextElementSibling;
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      if (body) body.classList.toggle('jdg-filter-collapsed', expanded);
    });
  });

  /* ── Mobile sidebar toggle ── */
  var filterBtn = document.getElementById('filterToggle');
  var sidebar = document.getElementById('jdgSidebar');
  var overlay = document.getElementById('sidebarOverlay');
  var closeBtn = document.getElementById('sidebarClose');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
  }
  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
  }

  if (filterBtn) filterBtn.addEventListener('click', openSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSidebar();
  });

  /* ── Grid view toggle (4-col / 2-col) ── */
  var grid = document.getElementById('productGrid');
  var btn4 = document.getElementById('gridView4');
  var btn2 = document.getElementById('gridView2');

  if (btn4 && btn2 && grid) {
    btn4.addEventListener('click', function () {
      grid.classList.remove('jdg-grid-2col');
      btn4.classList.add('active'); btn2.classList.remove('active');
    });
    btn2.addEventListener('click', function () {
      grid.classList.add('jdg-grid-2col');
      btn2.classList.add('active'); btn4.classList.remove('active');
    });
    // Auto 2-col on mobile
    if (window.innerWidth <= 480) grid.classList.add('jdg-grid-2col');
  }

  /* ── Price filter ── */
  var priceMin = document.getElementById('priceMin');
  var priceMax = document.getElementById('priceMax');
  var applyBtn = document.getElementById('applyPrice');

  document.querySelectorAll('.jdg-price-preset').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.jdg-price-preset').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      if (priceMin) priceMin.value = this.dataset.min || '';
      if (priceMax) priceMax.value = this.dataset.max || '';
    });
  });

  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var min = priceMin ? priceMin.value : '';
      var max = priceMax ? priceMax.value : '';
      var cards = document.querySelectorAll('.jdg-product-card[data-price]');
      var anyVisible = false;
      cards.forEach(function (card) {
        var price = parseInt(card.dataset.price) / 100; // Shopify stores in cents
        var show = true;
        if (min !== '' && price < parseInt(min)) show = false;
        if (max !== '' && max !== '0' && price > parseInt(max)) show = false;
        card.style.display = show ? '' : 'none';
        if (show) anyVisible = true;
      });
    });
  }

  /* ── Product type filter (checkboxes) ── */
  document.querySelectorAll('.jdg-type-filter').forEach(function (cb) {
    cb.addEventListener('change', function () {
      applyTypeFilters();
    });
  });

  function applyTypeFilters() {
    var checked = Array.from(document.querySelectorAll('.jdg-type-filter:checked')).map(function (c) { return c.value; });
    if (checked.length === 0) {
      document.querySelectorAll('.jdg-product-card[data-type]').forEach(function (c) { c.style.display = ''; });
      return;
    }
    document.querySelectorAll('.jdg-product-card[data-type]').forEach(function (card) {
      var type = card.dataset.type;
      card.style.display = checked.includes(type) ? '' : 'none';
    });
  }

  /* ── Quick View placeholder ── */
  document.querySelectorAll('.jdg-quick-view').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var handle = this.dataset.handle;
      if (handle) window.location.href = '/products/' + handle;
    });
  });

})();
